import { NotFoundPage } from "@/pages/not-found";
import { parseWebEditorUrl } from "@/utils/web-editor-link";
import type { JSX } from "react";
import { Navigate } from "react-router-dom";

/** Route of the WebEditor urls, which keep their original path when redirected to the viewer */
export const WEB_EDITOR_ROUTE = "/app/*";

/**
 * The WebEditor redirects to the Viewer by swapping the host only, so its urls arrive unchanged
 * and have to be translated before the viewer can open them.
 *
 * @returns the redirect to the viewer url, or the not found page for a url that cannot be read
 */
export function WebEditorRedirectPage(): JSX.Element {
  // The hash of a /app#editor/<id> url is only readable from the location, not from the router
  const viewerUrl = parseWebEditorUrl(new URL(window.location.href));

  if (!viewerUrl) return <NotFoundPage />;

  // Replace, so that going back does not land on the WebEditor url and redirect again
  return (
    <Navigate
      to={`${viewerUrl.pathname}${viewerUrl.search}${viewerUrl.hash}`}
      replace
    />
  );
}
